enum MapViewLocationIcon {
  Gate = 'gate',
  Zone = 'zone',
  Route = 'route',
  Equipment = 'equipment',
  Building = 'building',
  Line = 'line',
  TextBox = 'text-box',
  Level = 'level',
  Area = 'area',
  Logistics = 'logistics',
  Bathroom = 'bathroom',
  Break = 'break',
  Canteen = 'canteen',
  Dumpster = 'dumpster',
  Elevator = 'elevator',
  Shaft = 'shaft',
  Entrance = 'entrance',
  HandWash = 'hand-wash',
  Medical = 'medical',
  MeetingPoint = 'meeting-point',
  Parking = 'parking',
  Smoking = 'smoking',
  Stairs = 'stairs',
  Temperature = 'temperature',
  Tent = 'tent',
  Toilet = 'toilet',
  Walkway = 'walkway',
  ElectricalRoom = 'electrical-room',
  Crane = 'crane',
  Hoist = 'hoist',
  AerialLift = 'aerial-lift',
  Gradall = 'gradall',
  ForkLift = 'fork-lift',
  Monitoring = 'monitoring',
  InteriorPath = 'interior-path',
  InteriorDoor = 'interior-door',
  Staging = 'staging',
  Trailer = 'trailer',
  Project = 'project',
  Truck = 'truck',
  ConcreteMixerTruck = 'concrete-mixer-truck',
  EquipmentStorage = 'equipment-storage',
  MaterialStorageBoxes = 'material-storage-boxes',
  MaterialStorageWood = 'material-storage-wood',
  MaterialStorageSteel = 'material-storage-steel',
  MaterialStoragePipes = 'material-storage-pipes',
  MaterialLiftingSteel = 'material-lifting-steel',
  Scaffolding = 'scaffolding',
  SwingStage = 'swing-stage',
  PersonnelLift = 'personnel-lift',
  Info = 'info',
  SiteMap = 'site-map',
  LogOut = 'log-out',
  NoEntry = 'no-entry',
  Stop = 'stop',
  NoPedestrians = 'no-pedestrians',
  NoAccess = 'no-access',
  SecurityCheckpointWindow = 'security-checkpoint-window',
  VisitorCheck = 'visitor-check',
  HighVisibilityVest = 'high-visibility-vest',
  SafetyHelmet = 'safety-helmet',
  SafetyGloves = 'safety-gloves',
  SafetyToeBoots = 'safety-toe-boots',
  PpeNotRequired = 'ppe-not-required',
  NoVest = 'no-vest',
  NoHelmet = 'no-helmet',
  NoGloves = 'no-gloves',
  NoBoots = 'no-boots',
  CleanroomGowning = 'cleanroom-gowning',
  IcraZone = 'icra-zone',
  NegativePressure = 'negative-pressure',
  EsdZone = 'esd-zone',
  NoPhotography = 'no-photography',
  NoDrones = 'no-drones',
  FallHazard = 'fall-hazard',
  SilicaDust = 'silica-dust',
  Noise = 'noise',
  ConfinedSpace = 'confined-space',
  EnergizedEquipment = 'energized-equipment',
  BikeParking = 'bike-parking',
  UtilityCart = 'utility-cart',
  LoadingZone = 'loading-zone',
  FireLane = 'fire-lane',
  FlaggerAhead = 'flagger-ahead',
  OneWay = 'one-way',
  SpeedLimit = 'speed-limit',
  Trash = 'trash',
  AdminOffice = 'admin-office',
  HandWashStation = 'hand-wash-station',
  SpillKit = 'spill-kit',
  ErosionControl = 'erosion-control',
  StormDrainInletProtection = 'storm-drain-inlet-protection',
  ConcreteWashout = 'concrete-washout',
  WheelWash = 'wheel-wash',
  RestroomMen = 'restroom-men',
  RestroomWomen = 'restroom-women',
  Sofa = 'sofa',
  Hydration = 'hydration',
  HeartPulse = 'heart-pulse',
  Eyewash = 'eyewash',
  FireExtinguisher = 'fire-extinguisher',
  FireHydrant = 'fire-hydrant',
  FireAlarmButton = 'fire-alarm-button',
  StandpipeHose = 'standpipe-hose',
  Flame = 'flame',
  Excavator = 'excavator',
  OverheadLoad = 'overhead-load',
  BrandOes = 'brand-oes',
  BrandSunbelt = 'brand-sunbelt',
  BrandUnitedRentals = 'brand-united-rentals',
  BrandEquipmentshare = 'brand-equipmentshare',
  BrandFeco = 'brand-feco',
  BrandHercRentals = 'brand-herc-rentals',
}

/**
 * The icons an offloading-equipment can use. Single source of truth shared by
 * the resource form's icon field (General tab) and the map IconSelector (Map
 * tab) so the two pickers always offer the same set.
 */
export const OFFLOADING_EQUIPMENT_ICONS: MapViewLocationIcon[] = [
  MapViewLocationIcon.Equipment,
  MapViewLocationIcon.Crane,
  MapViewLocationIcon.Hoist,
  MapViewLocationIcon.AerialLift,
  MapViewLocationIcon.Gradall,
  MapViewLocationIcon.ForkLift,
]

/**
 * The icons a location can use. Everything in the enum except the offloading-equipment
 * glyphs, the map-only stickers (line, text box) and `monitoring`, which only the Maturix
 * integration mints.
 *
 * Kept beside OFFLOADING_EQUIPMENT_ICONS so the two pickers stay visibly different sets:
 * the resource form's icon field is shared, and before this existed it offered equipment
 * wrenches and forklifts when editing a level.
 */
export const LOCATION_ICONS: MapViewLocationIcon[] = [
  MapViewLocationIcon.Project,
  MapViewLocationIcon.Building,
  MapViewLocationIcon.Zone,
  MapViewLocationIcon.Staging,
  MapViewLocationIcon.Level,
  MapViewLocationIcon.Area,
  MapViewLocationIcon.Route,
  MapViewLocationIcon.Gate,
  MapViewLocationIcon.InteriorPath,
  MapViewLocationIcon.InteriorDoor,
  MapViewLocationIcon.Stairs,
  MapViewLocationIcon.Elevator,
  MapViewLocationIcon.Shaft,
  MapViewLocationIcon.Logistics,
  MapViewLocationIcon.Bathroom,
  MapViewLocationIcon.Break,
  MapViewLocationIcon.Canteen,
  MapViewLocationIcon.Dumpster,
  MapViewLocationIcon.Entrance,
  MapViewLocationIcon.HandWash,
  MapViewLocationIcon.Medical,
  MapViewLocationIcon.MeetingPoint,
  MapViewLocationIcon.Parking,
  MapViewLocationIcon.Smoking,
  MapViewLocationIcon.Temperature,
  MapViewLocationIcon.Tent,
  // Toilet is deliberately absent: markerSpec maps it and Bathroom to the same
  // RESTROOM_NODES glyph, so offering both puts two visually identical buttons in the
  // picker that store different values. The value stays valid and existing locations
  // using it still render - re-add it here once it has artwork of its own.
  MapViewLocationIcon.Walkway,
  MapViewLocationIcon.ElectricalRoom,
  MapViewLocationIcon.Trailer,
  MapViewLocationIcon.Truck,
  MapViewLocationIcon.ConcreteMixerTruck,
  MapViewLocationIcon.EquipmentStorage,
  MapViewLocationIcon.MaterialStorageBoxes,
  MapViewLocationIcon.MaterialStorageWood,
  MapViewLocationIcon.MaterialStorageSteel,
  MapViewLocationIcon.MaterialStoragePipes,
  MapViewLocationIcon.MaterialLiftingSteel,
  MapViewLocationIcon.Scaffolding,
  MapViewLocationIcon.SwingStage,
  MapViewLocationIcon.PersonnelLift,
  MapViewLocationIcon.Info,
  MapViewLocationIcon.SiteMap,
  MapViewLocationIcon.LogOut,
  MapViewLocationIcon.NoEntry,
  MapViewLocationIcon.Stop,
  MapViewLocationIcon.NoPedestrians,
  MapViewLocationIcon.NoAccess,
  MapViewLocationIcon.SecurityCheckpointWindow,
  MapViewLocationIcon.VisitorCheck,
  MapViewLocationIcon.HighVisibilityVest,
  MapViewLocationIcon.SafetyHelmet,
  MapViewLocationIcon.SafetyGloves,
  MapViewLocationIcon.SafetyToeBoots,
  MapViewLocationIcon.PpeNotRequired,
  MapViewLocationIcon.NoVest,
  MapViewLocationIcon.NoHelmet,
  MapViewLocationIcon.NoGloves,
  MapViewLocationIcon.NoBoots,
  MapViewLocationIcon.CleanroomGowning,
  MapViewLocationIcon.IcraZone,
  MapViewLocationIcon.NegativePressure,
  MapViewLocationIcon.EsdZone,
  MapViewLocationIcon.NoPhotography,
  MapViewLocationIcon.NoDrones,
  MapViewLocationIcon.FallHazard,
  MapViewLocationIcon.SilicaDust,
  MapViewLocationIcon.Noise,
  MapViewLocationIcon.ConfinedSpace,
  MapViewLocationIcon.EnergizedEquipment,
  MapViewLocationIcon.BikeParking,
  MapViewLocationIcon.UtilityCart,
  MapViewLocationIcon.LoadingZone,
  MapViewLocationIcon.FireLane,
  MapViewLocationIcon.FlaggerAhead,
  MapViewLocationIcon.OneWay,
  MapViewLocationIcon.SpeedLimit,
  MapViewLocationIcon.Trash,
  MapViewLocationIcon.AdminOffice,
  MapViewLocationIcon.HandWashStation,
  MapViewLocationIcon.SpillKit,
  MapViewLocationIcon.ErosionControl,
  MapViewLocationIcon.StormDrainInletProtection,
  MapViewLocationIcon.ConcreteWashout,
  MapViewLocationIcon.WheelWash,
  MapViewLocationIcon.RestroomMen,
  MapViewLocationIcon.RestroomWomen,
  MapViewLocationIcon.Sofa,
  MapViewLocationIcon.Hydration,
  MapViewLocationIcon.HeartPulse,
  MapViewLocationIcon.Eyewash,
  MapViewLocationIcon.FireExtinguisher,
  MapViewLocationIcon.FireHydrant,
  MapViewLocationIcon.FireAlarmButton,
  MapViewLocationIcon.StandpipeHose,
  MapViewLocationIcon.Flame,
  MapViewLocationIcon.Excavator,
  MapViewLocationIcon.OverheadLoad,
  MapViewLocationIcon.BrandUnitedRentals,
  MapViewLocationIcon.BrandSunbelt,
  MapViewLocationIcon.BrandHercRentals,
  MapViewLocationIcon.BrandEquipmentshare,
  MapViewLocationIcon.BrandFeco,
  MapViewLocationIcon.BrandOes,
]

/**
 * The StruxHub line glyphs drawn from Figma, generated into icons/libraryGlyphs/<shard>.generated.ts
 * by tools/glyphs/buildLibraryGlyphs.mjs. No location type draws one by default, so their art
 * loads on demand (icons/libraryGlyphs.ts).
 */
export const LIBRARY_GLYPHS = [
  MapViewLocationIcon.ConcreteMixerTruck,
  MapViewLocationIcon.EquipmentStorage,
  MapViewLocationIcon.MaterialStorageBoxes,
  MapViewLocationIcon.MaterialStorageWood,
  MapViewLocationIcon.MaterialStorageSteel,
  MapViewLocationIcon.MaterialStoragePipes,
  MapViewLocationIcon.MaterialLiftingSteel,
  MapViewLocationIcon.Scaffolding,
  MapViewLocationIcon.SwingStage,
  MapViewLocationIcon.PersonnelLift,
  MapViewLocationIcon.SiteMap,
  MapViewLocationIcon.NoEntry,
  MapViewLocationIcon.Stop,
  MapViewLocationIcon.NoPedestrians,
  MapViewLocationIcon.NoAccess,
  MapViewLocationIcon.SecurityCheckpointWindow,
  MapViewLocationIcon.VisitorCheck,
  MapViewLocationIcon.HighVisibilityVest,
  MapViewLocationIcon.SafetyHelmet,
  MapViewLocationIcon.SafetyGloves,
  MapViewLocationIcon.SafetyToeBoots,
  MapViewLocationIcon.PpeNotRequired,
  MapViewLocationIcon.NoVest,
  MapViewLocationIcon.NoHelmet,
  MapViewLocationIcon.NoGloves,
  MapViewLocationIcon.NoBoots,
  MapViewLocationIcon.CleanroomGowning,
  MapViewLocationIcon.IcraZone,
  MapViewLocationIcon.NegativePressure,
  MapViewLocationIcon.EsdZone,
  MapViewLocationIcon.NoPhotography,
  MapViewLocationIcon.NoDrones,
  MapViewLocationIcon.FallHazard,
  MapViewLocationIcon.SilicaDust,
  MapViewLocationIcon.Noise,
  MapViewLocationIcon.ConfinedSpace,
  MapViewLocationIcon.EnergizedEquipment,
  MapViewLocationIcon.BikeParking,
  MapViewLocationIcon.UtilityCart,
  MapViewLocationIcon.LoadingZone,
  MapViewLocationIcon.FireLane,
  MapViewLocationIcon.FlaggerAhead,
  MapViewLocationIcon.OneWay,
  MapViewLocationIcon.SpeedLimit,
  MapViewLocationIcon.AdminOffice,
  MapViewLocationIcon.HandWashStation,
  MapViewLocationIcon.SpillKit,
  MapViewLocationIcon.ErosionControl,
  MapViewLocationIcon.StormDrainInletProtection,
  MapViewLocationIcon.ConcreteWashout,
  MapViewLocationIcon.WheelWash,
  MapViewLocationIcon.RestroomMen,
  MapViewLocationIcon.RestroomWomen,
  MapViewLocationIcon.Hydration,
  MapViewLocationIcon.Eyewash,
  MapViewLocationIcon.FireExtinguisher,
  MapViewLocationIcon.FireHydrant,
  MapViewLocationIcon.FireAlarmButton,
  MapViewLocationIcon.StandpipeHose,
  MapViewLocationIcon.Excavator,
  MapViewLocationIcon.OverheadLoad,
  MapViewLocationIcon.BrandUnitedRentals,
  MapViewLocationIcon.BrandSunbelt,
  MapViewLocationIcon.BrandHercRentals,
  MapViewLocationIcon.BrandEquipmentshare,
  MapViewLocationIcon.BrandFeco,
  MapViewLocationIcon.BrandOes,
] as const

export type LibraryGlyph = (typeof LIBRARY_GLYPHS)[number]

/**
 * The StruxHub icons the library adds to the original location set: the generated glyphs and the
 * Lucide ones. No type draws one by default, so a location carrying one picked it for its own sake.
 */
export const LIBRARY_ICONS: ReadonlySet<string> = new Set<string>([
  ...LIBRARY_GLYPHS,
  MapViewLocationIcon.Truck,
  MapViewLocationIcon.Info,
  MapViewLocationIcon.LogOut,
  MapViewLocationIcon.Trash,
  MapViewLocationIcon.Sofa,
  MapViewLocationIcon.HeartPulse,
  MapViewLocationIcon.Flame,
])

export default MapViewLocationIcon
